import { memo } from 'react';
import { locales } from '../../../../locales/en';
import "./BigGif.linaria.module.css!=!./BigGif?./BigGif.linaria.module.css?css=H4sIAAAAAAAAA12RzY6CMBSF9z4FG5OZBQ4XdAbrwzT9hWJpK1R+bHz3CTow4qJpTs53Tm9ud8TX+Nhi8EOvOh24ap0mI5JaDKf7ZjfZpMFA3d6e2ZsMExVz1QjmlTWIWX2tzRyjAsPlyFhxe5PPWN8Qh4ydrjmhLRYD8zldq+AI58oUsbcOwbdbBtNnLH2hdLpWC6+F9Cj/51mLc5NBStcqSGt83AtVlB5Rq/nSr1f9+r2/eSReHsgkhqvoRJkHahsuGgRuiFqrFY+agn4ApNF8vqLssP1cdlxjsFTmQ/LYDoIIIkiS7eyLFINtLzbtQvkc9NVVI+5ulDsINRniP2CfdOUMVNkSn4hecV+uGiqHQR5A/MhgaSWYj6XyiFnjiVp+VDKsPLtdkrUK1bX1So7xhAvjUesIE7HohNHj6b75BXezV9pkAgAA"
const captionStyles = "atm_9s_1txwivl atm_ar_1bp4okc atm_be_1q9ccgz atm_lo_exct8b";
const captionCellStyles = "atm_lk_ftgil2";
const captionCellLeftStyles = "atm_cs_8n312b atm_ll_ftgil2";
const mediaStyles = "atm_3f_1ueveh8 atm_am_1obf8x0 atm_e2_1osqo2v atm_iy_vzbdp1 atm_j3_1osqo2v atm_jp_1f51e7f";
const captionRowStyles = "atm_9s_1txwivl atm_fc_itczq0";
export interface ImageData {
  username: string;
  shortcut: string;
  src: string;
}
interface IBigGif {
  imageData: ImageData;
}
const BigGif = memo((props: IBigGif) => {
  const {
    imageData: {
      username,
      shortcut,
      src
    }
  } = props;
  return <>
            <img src={src} alt={shortcut} className={mediaStyles} />
            <div className={captionStyles}>
                {!!username && <div className={captionRowStyles}>
                        <span className={captionCellLeftStyles}>
                            {locales.chatImages.submittedBy + ':'}
                        </span>
                        <span className={captionCellStyles}>{username}</span>
                    </div>}
                {!!shortcut && <div className={captionRowStyles}>
                        <span className={captionCellLeftStyles}>
                            {locales.chatImages.shortcut + ':'}
                        </span>
                        <span className={captionCellStyles}>{shortcut}</span>
                    </div>}
            </div>
        </>;
});
export default BigGif;